export const createRecentOrderLookupParams = (product) => ({
  last_hour: true,
  object_id: product.id,
  ...(product.event_product_listing_id && {
    event_product_listing_id: product.event_product_listing_id,
  }),
  ...(product.selected_variant && {
    product_variant_id: product.selected_variant.id,
  }),
});
